import { default as filenames } from '../assets/i18n/_i18nmappings.json';

export const environmentCommon = {
	appName: 'iTSingle invoice',
	appVersion: '1.0.0',
	translations: {
		/* if the website has translation */
		enabled: true,
		merged: true,
		filenames: (filenames as unknown) as string[]
	},
	loginConfig: {
		passwordMinLength: 8
	}
};
